import TemporaryAbonent from '@/services/api/temporaryAbonent.js';

export default {
  namespaced: true,
  state: {
    temporaryAbonents: [],
    temporaryAbonent: {},
    deletedAbonents: [],
    deletedAbonent: {},
  },
  mutations: {
    setAbonents: (state, abonents) => {
      state.temporaryAbonents = abonents;
    },
    setDeletedAbonents: (state, deletedAbonents) => {
      state.deletedAbonents = deletedAbonents;
    },
    setAbonent: (state, abonent) => {
      state.temporaryAbonent = abonent;
    },
  },
  actions: {
    loadTemporaryAbonents (state, options = {}) {
      return new Promise((resolve, reject) => {
        TemporaryAbonent.loadTemporaryAbonents(options)
          .then(({ data }) => {
            state.commit('setAbonents', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },

    updateTemporaryAbonent (state, { data, id }) {
      return new Promise((resolve, reject) => {
        TemporaryAbonent.updateTemporaryAbonent({ data, id })
          .then(({ data }) => {
            state.commit('setAbonent', data.data);
            state.dispatch('getAbonent', id);
            resolve({ data });
          })
          .catch(e => reject(e));
      });
    },

    newTemporaryAbonent (state, data) {
      return new Promise((resolve, reject) => {
        TemporaryAbonent.newTemporaryAbonent(data)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },

    deleteTemporaryAbonent (state, { id }) {
      return new Promise((resolve, reject) => {
        TemporaryAbonent.deleteTemporaryAbonent(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
  },
};
